module.exports = __webpack_public_path__ + "img/kuaishou.768ab396.png";